export const currencyFormat = (amount, options = {}) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "UGX",
    maximumFractionDigits: 3,
    minimumFractionDigits: 0,
    useGrouping: true,
    notation: "standard",
    ...options,
  }).format(amount);
};
